<div class="avatar d-flex">
    <span class="align-self-center me-1">{{user}}</span>
    <!-- TODO: add profile image displaying if exists -->
    <div class="rounded-circle avatar-icon d-grid ">
        <span>{{getAvatarLetters()}}</span>
    </div>
</div>
